import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTextBolder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 6C7 5.44772 7.44772 5 8 5H17.5C18.9587 5 20.3576 5.57946 21.3891 6.61091C22.4205 7.64236 23 9.04131 23 10.5C23 11.9587 22.4205 13.3576 21.3891 14.3891C21.3639 14.4142 21.3386 14.4391 21.313 14.4637C22.0275 14.7623 22.6844 15.1991 23.2426 15.7574C24.3679 16.8826 25 18.4087 25 20C25 21.5913 24.3679 23.1174 23.2426 24.2426C22.1174 25.3679 20.5913 26 19 26H8C7.44772 26 7 25.5523 7 25V6ZM9 16V24H19C20.0609 24 21.0783 23.5786 21.8284 22.8284C22.5786 22.0783 23 21.0609 23 20C23 18.9391 22.5786 17.9217 21.8284 17.1716C21.0783 16.4214 20.0609 16 19 16H9ZM17.5 14H9V7H17.5C18.4283 7 19.3185 7.36875 19.9749 8.02513C20.6313 8.6815 21 9.57174 21 10.5C21 11.4283 20.6313 12.3185 19.9749 12.9749C19.3185 13.6313 18.4283 14 17.5 14Z"
	})
});
export default SvgTextBolder;
